<div class="login-container">
  <!-- Left Panel -->
  <div class="left-panel">

    <div class="top-logos">
      <img src="assets/dashboard icons/logo1.png">
      <img src="assets/dashboard icons/logo2.png">
      <img class="asha-saathi-logo" src="assets/dashboard icons/ashasathilogo.png">
      <img src="assets/dashboard icons/logo4.png">
      <img src="assets/dashboard icons/logo5.png">
    </div>

    <!-- <div class="left-panel-text">
      Accredited Social Health Activists
    </div> -->
    <div class="left-panel-text">
  {{ isMr
    ? 'मान्यताप्राप्त सामाजिक आरोग्य कार्यकर्त्या'
    : 'Accredited Social Health Activists' }}
</div>
  <img src="assets/dashboard icons/AshaPic.png" alt="Asha" />
  </div>

  <div class="right-container">
    <div class="login-card">
      <!-- Desktop logo -->
         <img src="assets/icons/headericon_pink.png" alt="Asha" />
      <!-- <h2 class="login-title">Create New Password</h2> -->
       <h2 class="login-title">
  {{ isMr ? 'नवीन पासवर्ड तयार करा' : 'Create New Password' }}
</h2>

      <!-- Mobile replacement image -->
      <img src="assets/loginImg.png" alt="Asha" class="mobile-login-image" />
      <!-- <p class="login-subtitle">Create new password for your account</p> -->
<p class="login-subtitle">
  {{ isMr
    ? 'तुमच्या खात्यासाठी नवीन पासवर्ड तयार करा'
    : 'Create new password for your account' }}
</p>
      <form class="login-form" (submit)="onSubmit()">

        <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top" class="custom-login-form"
          [showColonAfterLabel]="false">

          <dxi-form-item dataField="password" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
               placeholder: isMr ? 'नवीन पासवर्ड टाका' : 'Enter your password',
              mode: passwordMode,
              buttons: [{
                name: 'togglePassword',
                id:'password',
                value: formData.password,
                location: 'after',
                options: {
                  icon: passwordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                  onClick: togglePasswordVisibility
                }
              }]
            }">
            <!-- <dxo-label text="New Password"></dxo-label> -->
              <dxo-label
    [text]="isMr ? 'नवीन पासवर्ड' : 'New Password'">
  </dxo-label>
            <!-- <dxi-form-validation-rule type="required" message="Password is required"></dxi-form-validation-rule> -->
          </dxi-form-item>

          <dxi-form-item dataField="confirmpassword" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
               placeholder: isMr ? 'पासवर्डची पुष्टी करा' : 'Enter Confirm Password',
              mode: confirmpasswordMode,
              buttons: [{
                name: 'togglePassword',
                id:'confirmpassword',
                value: formData.confirmpassword,
                location: 'after',
                options: {
                  icon: confirmpasswordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                  onClick: toggleConfirmPasswordVisibility
                }
              }]
            }">
            <!-- <dxo-label text="Confirm New Password"></dxo-label> -->
             <dxo-label
    [text]="isMr ? 'पासवर्डची पुष्टी' : 'Confirm Password'">
  </dxo-label>
            <!-- <dxi-form-validation-rule type="required" message="Password is required"></dxi-form-validation-rule> -->
          </dxi-form-item>
        </dx-form>

        <dx-button [text]="isMr ? 'जतन करा' : 'Save'" type="default" stylingMode="contained" class="login-button"
          (click)="onSubmit()"></dx-button>
      </form>
    </div>
  </div>
</div>